import { cn } from '@/lib/utils';
import ChangePackageSummaryStepSkeleton from './ChangePackageSummaryStepSkeleton';

/**
 * `pendingComponent` trasy przepływu. Wejście zawsze zaczyna się od kroku W1,
 * więc szkielet strony odwzorowuje właśnie jego układ.
 */
const ChangePackageFlowPageSkeleton = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn('flex w-full max-w-[1356px] flex-col gap-4', className)}
    {...props}
  >
    <ChangePackageSummaryStepSkeleton />
  </div>
);

export default ChangePackageFlowPageSkeleton;
